import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { CategoriesService } from 'src/app/services/categori.service';

@Component({
  standalone: false,
  selector: 'app-all-users',
  templateUrl: './all-users.component.html',
  styleUrls: ['./all-users.component.css'],
})
export class AllUsersComponent implements OnInit {
  usersArr: any[] = [];
  totalCount = 0;
  page = 1;
  limit = 10;
  searchValue = '';
  selectedRow: any;
  isLoading = true;
  hasError = false;

  displayedColumns: string[] = ['id', 'name', 'username', 'email', 'role', 'actions'];

  constructor(private rest: CategoriesService, private router: Router) {}

  ngOnInit() {
    this.rest.showSpinner();
    this.loadUsers();
  }

  loadUsers() {
    this.isLoading = true;
    this.hasError = false;
    this.rest.getAllUsers(this.page, this.limit, this.searchValue || undefined).subscribe({
      next: (res: any) => {
        this.rest.hideSpinner();
        this.isLoading = false;
        this.usersArr = res?.users || [];
        this.totalCount = res?.total_count || 0;
      },
      error: (err: any) => {
        this.rest.hideSpinner();
        this.isLoading = false;
        this.hasError = true;
        const msg = err?.error?.message || 'Failed to load users. Check that the server is running.';
        this.rest.errorToaster(msg);
        console.error('Users API error:', err);
      },
    });
  }

  onSearch(event: any) {
    this.page = 1;
    this.searchValue = event?.target?.value || '';
    this.loadUsers();
  }

  changePage(e: PageEvent) {
    this.page = e.pageIndex + 1;
    this.loadUsers();
  }

  goToDetails(id: number) {
    this.router.navigate(['main/user_details', id]);
  }

  onRowHovered(row: any) {
    this.selectedRow = row;
  }

  handleMouseLeave() {
    this.selectedRow = null;
  }
}
